import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { Button } from 'shpmtcd'
import list from '../../App/TabList.json'

const MenuList = ({ id, menuName, onClickCallback }) => (
  <div
    className='menu-wrapper'
    id={id}
    onClick={() => onClickCallback(id)}
    onKeyDown={() => onClickCallback(id)}
  >
    {
      id === 'logout' ? <div className='line-separator' /> : null
    }
    {menuName}
  </div>
)

class AccountDropdown extends Component {
  render() {
    const {
      isSignedIn, onMenuClick,
    } = this.props
    const MenuArray = list.tabList
    return (
      <div className='dropdown-wrapper'>
        {
          !isSignedIn
            ? (
              <section>
                <p className='welcome-message'>
                  <h6>Welcome</h6>
                  To access account &amp; manage orders
                </p>
                <Link to='/sigin' className='sign-btn'>
                  <Button type='Primary'>
                    Sign in
                  </Button>
                </Link>
                <Link to='/signup' className='new-customer-register'>
                  <p className='new-register'> New customer?  <span> Register </span> </p>
                </Link>
              </section>
            )
            : null
        }
        { !isSignedIn ? <div className='line-separator' /> : null}
        {
          MenuArray.map((x) => {
            if (!isSignedIn) {
              if (x.id !== 'logout' && x.id !== 'changePassword') {
                return (
                  <MenuList
                    key={x.id}
                    id={x.id}
                    menuName={x.text}
                    onClickCallback={(id) => onMenuClick(id)}
                  />
                )
              }
              return null
            }
            return (
              <MenuList
                key={x.id}
                id={x.id}
                menuName={x.text}
                onClickCallback={(id) => onMenuClick(id)}
              />
            )
          })
        }
      </div>
    )
  }
}

MenuList.propTypes = {
  id: PropTypes.string.isRequired,
  menuName: PropTypes.string.isRequired,
  onClickCallback: PropTypes.func.isRequired,
}

AccountDropdown.propTypes = {
  isSignedIn: PropTypes.bool.isRequired,
  onMenuClick: PropTypes.func.isRequired,
}

export default AccountDropdown
